import React from 'react';
import { bonuses } from '../data/content';
import { CtaButton } from './CtaButton';
export function Bonuses() {
  return <section aria-labelledby="bonus-title" className="border-y-2 border-ink bg-cream" data-id="element-13" data-mp="piy2uloqjvk1">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-24" data-id="element-14" data-mp="avv1u517f4ry">
        <div className="max-w-2xl" data-id="element-15" data-mp="fu6cghzbpjb8">
          <p className="font-display text-lg font-medium italic text-kraft-dark" data-id="element-16" data-mp="ftejlex41zon">Y además del diario te llevas</p>
          <h2 id="bonus-title" className="mt-2 font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-17" data-mp="1tlutp559tjb">
            5 bonos de acción rápida
          </h2>
        </div>

        <ul className="mt-10 grid gap-x-6 gap-y-8 sm:mt-12 sm:gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="3o2n1rsbtlugh">
          {bonuses.map(b => <li key={b.number} className="relative flex flex-col rounded-2xl border-2 border-ink bg-paper px-5 pb-5 pt-9 sm:px-6 sm:pb-6 sm:pt-10" data-id="element-19" data-mp="3t0yc046126z8">
              <span className="absolute -top-5 left-6 flex h-10 min-w-[3.5rem] items-center justify-center rounded-b-2xl rounded-t-md bg-ink px-3 font-display text-lg font-black text-cream" data-id="element-20" data-mp="1r9v07bkeimd3">
                #{b.number}
              </span>
              <p className="font-display text-xs font-bold uppercase tracking-wider text-kraft-dark" data-id="element-21" data-mp="3detvuyufwyu5">Bono {b.number}</p>
              <h3 className="mt-1 font-display text-xl font-extrabold leading-snug" data-id="element-22" data-mp="3r8ukv0vlb7hb">{b.title}</h3>
              <p className="mt-3 flex-1 leading-relaxed text-ink-soft" data-id="element-23" data-mp="3n79dtw5qlnf1">{b.text}</p>
              <div className="mt-6 flex items-center justify-between border-t border-dashed border-kraft-dark/50 pt-4" data-id="element-24" data-mp="2zg3wfck5en2m">
                <span className="text-sm text-ink-soft" data-id="element-25" data-mp="2uikbjtsy3c1p">
                  Valor <s className="font-bold" data-id="element-26" data-mp="38h1t19s9bsb6">{b.value}</s>
                </span>
                <span className="rounded-full bg-rust px-3 py-1 font-display text-sm font-extrabold" data-id="element-27" data-mp="33gw80cght422">Hoy gratis</span>
              </div>
            </li>)}
          <li className="flex flex-col items-start justify-center gap-4 rounded-2xl bg-ink p-6 text-cream sm:col-span-2 lg:col-span-1" data-id="element-28" data-mp="ns49e6h8o288">
            <p className="font-display text-2xl font-black leading-tight" data-id="element-29" data-mp="3cjfxta97slhv">
              Todos los bonos incluidos al comprar hoy.
            </p>
            <CtaButton label="Sí, abro mi diario" tone="light" data-id="element-30" data-mp="3hg6dhwh3xf2r" />
          </li>
        </ul>
      </div>
    </section>;
}